/* LL Brief 104A: inline Our Story video activation. */
(() => {
  if (customElements.get('ll-os-video')) return;

  class LLOurStoryVideo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.button = this.querySelector('[data-os-play]');
      this.button?.addEventListener('click', () => this.play());
    }

    play() {
      const video = this.querySelector('video[data-os-hosted]');
      const embed = this.querySelector('[data-os-embed]');
      this.classList.add('is-playing');
      this.button?.setAttribute('hidden', '');

      if (video) {
        video.hidden = false;
        video.muted = false;
        video.controls = true;
        video.play().catch(() => video.focus());
        return;
      }

      if (!embed || embed.querySelector('iframe')) return;
      const provider = embed.dataset.provider;
      const id = embed.dataset.videoId;
      const title = embed.dataset.title || 'Lean Living video';
      let src = '';
      if (provider === 'youtube') src = `https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1&playsinline=1&rel=0`;
      if (provider === 'vimeo') src = `https://player.vimeo.com/video/${encodeURIComponent(id)}?autoplay=1&playsinline=1`;
      if (!src) return;

      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = title;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      embed.appendChild(iframe);
    }
  }

  customElements.define('ll-os-video', LLOurStoryVideo);
})();
